module.exports = __webpack_public_path__ + "00e4795f8015b2220bf395e86f1e4bb6.png";